import * as ActionCable from "@rails/actioncable";
import { enableMapSet } from "immer";
import "./config/extensions/yup";

if (import.meta.env.MODE === "development") {
  ActionCable.logger.enabled = true;
}

enableMapSet();
